<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="description_manufacturing_process" name="description_manufacturing_process" rules="required" v-slot="{ errors }">
              <small class="label">Description of manufacturing process (including any processing times and temperatures)
              </small>
              <vs-textarea name="description_manufacturing_process" v-model="form.description_manufacturing_process" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="final_sieve_size" name="final_sieve_size" rules="required" v-slot="{ errors }">
              <small class="label">Final sieve/mesh size</small>
              <vs-input type="text" v-model="form.final_sieve_size" name="final_sieve_size" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_metal_detection" name="is_metal_detection" rules="" v-slot="{ errors }">
              <small class="label">Metal Detection in place?</small>
              <vs-switch v-model="form.is_metal_detection" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>

        </div>

        <div class="vx-row mb-3">
          <!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
          <!--            <ValidationProvider v-if="form.is_metal_detection" vid="is_metal_detection_comment" name="is_metal_detection_comment" rules="required" v-slot="{ errors }">-->
          <!--              <small class="label">If yes,please specify</small>-->
          <!--              <vs-input type="text" name="is_metal_detection_comment" class="w-full" v-model="form.is_metal_detection_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
          <!--            </ValidationProvider>-->
          <!--          </div>-->
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_metal_detection" vid="metal_detector_sensitivity_ferrous" name="metal_detector_sensitivity_ferrous" rules="" v-slot="{ errors }">
              <small class="label">Metal Detector Sensitivity (Ferrous)</small>
              <vs-input type="text" name="metal_detector_sensitivity_ferrous" class="w-full" v-model="form.metal_detector_sensitivity_ferrous" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_metal_detection" vid="metal_detector_sensitivity_non_ferrous" name="metal_detector_sensitivity_non_ferrous" rules="" v-slot="{ errors }">
              <small class="label">Metal Detector Sensitivity (Non-Ferrous)</small>
              <vs-input type="text" name="metal_detector_sensitivity_non_ferrous" class="w-full" v-model="form.metal_detector_sensitivity_non_ferrous" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_metal_detection" vid="metal_detector_sensitivity_stainless_steel" name="metal_detector_sensitivity_stainless_steel" rules="" v-slot="{ errors }">
              <small class="label">Metal Detector Sensitivity (Stainless Steel)</small>
              <vs-input type="text" name="metal_detector_sensitivity_stainless_steel" class="w-full" v-model="form.metal_detector_sensitivity_stainless_steel" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_metal_detection">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_magnets_used" name="is_magnets_used" rules="" v-slot="{ errors }">
              <small class="label">Magnets used?</small>
              <vs-switch v-model="form.is_magnets_used" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_magnets_used" vid="is_magnets_used_comment" name="is_magnets_used_comment" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_magnets_used_comment" class="w-full" v-model="form.is_magnets_used_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>

        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import RawMaterialForm from "@/mixins/RawMaterialForm";

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_metal_detection: false,
          is_magnets_used: false
        },
        id: null,
        status: {},
      }
    },
    props : {
      isCompleted: { default: false }
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_manufacturing_process_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_manufacturing_process_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialManufacturingProcess(this.id, this.form))
          this.showSuccessMessage('Raw Material Manufacturing Process Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialManufacturingProcess(this.form))
          this.showSuccessMessage('Raw Material Manufacturing Process Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialManufacturingProcess(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_manufacturing_process_complete) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
